import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Share2 } from "lucide-react";
import { pdfjs } from "react-pdf";

import Header from "src/components/app/layout/Header";
import Layout from "src/components/app/layout/Layout";
import Loader from "src/components/common/Loader";

import { sendMessageToParent } from "src/helpers/common";
import { POST_MESSAGE_EVENTS } from "src/constants/common";

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.mjs",
  import.meta.url
).toString();

const ViewRecordScreen: React.FC = () => {
  const { record } = useLocation().state || {};
  const navigate = useNavigate();
  //const [numPages, setNumPages] = useState<number>();
  const [pdfViewerUrl, setPdfViewerUrl] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const params = useParams();
  const supportProgramKey = params["support-program-key"];

  useEffect(() => {
    const url =
      Array.isArray(record?.document_url) && record?.document_url?.length > 0
        ? record?.document_url[0]
        : record?.document_url;

    if (url) {
      const viewerUrl = `https://docs.google.com/gview?url=${encodeURIComponent(
        url
      )}&embedded=true#toolbar=0&navpanes=0&scrollbar=1&view=fitH&zoom=100&pagemode=none`;
      setPdfViewerUrl(viewerUrl);
      setIsLoading(true); // make sure loading starts

      // Fallback: Hide loader after 1.5 seconds
      const timeout = setTimeout(() => {
        setIsLoading(false);
      }, 2500);

      return () => clearTimeout(timeout);
    }
  }, [record]);

  const handleShare = () => {
    const payload = {
      documentLink:
        Array.isArray(record?.document_url) && record?.document_url?.length > 0
          ? record?.document_url[0]
          : record?.document_url,
      documentName: record?.title,
    };
    sendMessageToParent(POST_MESSAGE_EVENTS.SHARE_RECORD_DOCUMENT, payload);
  };

  // const onDocumentLoadSuccess = ({ numPages }: { numPages: number }): void => {
  //   setNumPages(numPages);
  // };

  return (
    <Layout supportProgramKey={supportProgramKey || ""}>
      <div className="relative pt-[52px] h-full">
        <div className="fixed max-w-lg mx-auto top-0 left-0 right-0 z-10">
          <Header
            title={record?.document_name}
            onBackClick={() => navigate(-1)}
            rightComponent={
              <button
                className="w-10 h-10 rounded-full active:bg-gray-200 flex items-center justify-center"
                onClick={handleShare}
              >
                <Share2 className="w-5 h-5" />
              </button>
            }
          />
        </div>
        <div className="w-full max-w-lg h-full bg-white">
          {isLoading ? (
            <div className="w-full h-[calc(100vh-53px)] bg-white flex items-center justify-center">
              <Loader size="lg" />
            </div>
          ) : (
            <iframe
              title="pdf-viewer"
              src={pdfViewerUrl} // &embedded=true#toolbar=0&navpanes=0&scrollbar=1&view=fitH&zoom=100&pagemode=none
              allow="fullscreen"
              className="w-full h-full bg-white"
              style={{
                border: "none",
                backgroundColor: "white", // Ensures iframe background is white while loading
              }}
            ></iframe>
          )}
          {/* <Document
          file={
            Array.isArray(record?.document_url) &&
            record?.document_url?.length > 0
              ? record?.document_url[0]
              : record?.document_url
          }
          onLoadSuccess={onDocumentLoadSuccess}
          loading={
            <div className="w-full h-[calc(100vh-53px)] bg-white flex items-center justify-center">
              <Loader size="lg" />
            </div>
          }
        >
          {Array.apply(null, Array(numPages)).map((_, index) => (
            <Page
              pageNumber={index + 1}
              renderAnnotationLayer={false}
              renderTextLayer={false}
              className="w-full h-full bg-white mb-1"
              width={375}
            />
          ))}
        </Document> */}
        </div>
      </div>
    </Layout>
  );
};

export default ViewRecordScreen;
